import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { RootState } from '../reduxStore';
import { hideLoader, showLoader } from './loaderSlice';
import { showErrorSnackbar } from './snackbarSlice';
import { authActions } from './authSlice';
import { getOrderProcessing, getOrderProcessingByPage } from '../../ApiServices/OrderProcessing';
import { t } from 'i18next';

export const initialState = {
  value: { totalCount: -1, data: [{}] },
  loading: false,
  error: null,
  selectedValue: null,
  rowsPerPage: 10,
  pageNo: 0,
  sortBy: '',
  sortDirection: 0
};

const orderProcessingSlice = createSlice({
  name: 'orderProcessing',
  initialState: initialState,
  reducers: {
    clearOrderProcessingState(state: any) {
      state.rowsPerPage = initialState.rowsPerPage;
      state.pageNo = initialState.pageNo;
      state.value = initialState.value;
      state.loading = false;
      state.error = null;
      state.selectedValue = initialState.selectedValue;
    }
  },
  extraReducers: builder => {
    builder.addCase(fetchOrderProcessing.fulfilled, (state: any, action: any) => {
      state.error = initialState.error;
      state.loading = initialState.loading;
      state.selectedValue = initialState.selectedValue;
      state.value = action?.payload?.data;
      state.pageNo = action?.meta?.arg?.page;
      state.rowsPerPage = action?.meta?.arg?.limit;
      state.sortBy = action?.meta?.arg?.sortBy;
      state.sortDirection = action?.meta?.arg?.sortDirection;
    });
    builder.addCase(fetchOrderProcessing.rejected, (state: any, action: any) => {
      state.error = action?.payload?.error?.message;
      state.loading = false;
      state.selectedValue = initialState?.selectedValue;
    });
    builder.addCase(fetchOrderProcessingById.fulfilled, (state: any, action: any) => {
      state.error = initialState.error;
      state.loading = initialState.loading;
      state.message = action?.payload?.data;
    });
    builder.addCase(fetchOrderProcessingById.rejected, (state: any, action: any) => {
      state.loading = initialState.loading;
      state.error = action?.payload?.data;
    });
  }
});

export const orderProcessingState = (state: RootState) => state?.orderProcessing;
export const { clearOrderProcessingState } = orderProcessingSlice.actions;
export default orderProcessingSlice.reducer;

export const fetchOrderProcessing = createAsyncThunk(
  'orderProcessing/fetchOrderProcessing',
  async (payload: any, { fulfillWithValue, rejectWithValue, dispatch }) => {
    try {
      dispatch(showLoader({ message: t('FETCHING_ORDERPROCESSING') }));
      return fulfillWithValue(await getOrderProcessingByPage(payload));
    } catch (error) {
      dispatch(showErrorSnackbar({ message: error }));
      return rejectWithValue(error);
    } finally {
      dispatch(hideLoader());
    }
  }
);

export const fetchOrderProcessingById = createAsyncThunk(
  'orderProcessing/fetchOrderProcessingById',
  async (payload: any, { fulfillWithValue, rejectWithValue, dispatch }) => {
    try {
      dispatch(showLoader({ message: t('FETCHING_ORDERPROCESSING_DETAILS') }));
      return fulfillWithValue(await getOrderProcessing(payload));
    } catch (error) {
      dispatch(showErrorSnackbar({ message: error }));
      return rejectWithValue(error);
    } finally {
      dispatch(hideLoader());
    }
  }
);
